






























import { defineComponent, PropType, computed } from "@vue/composition-api";
export default defineComponent({
	props:{
		value:{
			type:Boolean
		},
		open:{
			type:Boolean
		},
		variant:{
			type:String,
			default:"dark"
		},
		title:{
			type:String,
			default:"Menu"
		},
		icon:{
			type:String,
			default:""
		}
	},
	setup(props){

		const textVariant = computed(() => {


			return ({
				"light":"dark",
			} as any)[props.variant] || "light"


		});


		return {
			textVariant,
		};
	}
})

